<mat-paginator [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
